import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useTheme } from '../../context/ThemeContext';
import { Outlet } from 'react-router-dom';
interface LayoutProps {
  children?: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const {
    theme
  } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <div className={`flex h-screen w-full bg-gray-50 ${theme === 'dark' ? 'dark bg-gray-900 text-white' : ''}`} data-id="element-170">
      <Sidebar isOpen={sidebarOpen} data-id="element-171" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-172">
        <Header toggleSidebar={toggleSidebar} data-id="element-173" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-174">
          {children || <Outlet data-id="element-175" />}
        </main>
      </div>
    </div>;
};
export default Layout;